module.exports = __webpack_public_path__ + "static/media/blairLunch-large.676c736c.png";